var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sideCollapse",attrs:{"id":"domColapse"}},[_c('i',{class:{ 'el-icon-s-unfold': _vm.opened, 'el-icon-s-fold': !_vm.opened },on:{"click":function($event){return _vm.toggleOpen()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }